function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.25 18C3.49264 18 4.5 16.9926 4.5 15.75C4.5 14.5074 3.49264 13.5 2.25 13.5C1.00736 13.5 0 14.5074 0 15.75C0 16.9926 1.00736 18 2.25 18Z",
  fill: "#141414"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0V3.27378C8.13239 3.27378 14.7262 9.86761 14.7262 18H18C18 8.06298 9.93702 0 0 0ZM0 6.54756V9.82134C4.51157 9.82134 8.17866 13.4884 8.17866 18H11.4524C11.4524 11.6722 6.32776 6.54756 0 6.54756Z",
  fill: "#141414"
});

function SvgNewsFeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsFeed);
export default __webpack_public_path__ + "static/media/newsFeed.4cd45556.svg";
export { ForwardRef as ReactComponent };